const viewPanels = Array.from(
  document.querySelectorAll("[data-workspace-view-panel]")
);
const viewLinks = Array.from(
  document.querySelectorAll("[data-workspace-view-link]")
);
const tabButtons = Array.from(document.querySelectorAll(".workspace-tab"));
const tabPanels = Array.from(
  document.querySelectorAll("[data-workspace-tab-panel]")
);

const COMPATIBLE_HASHES = {
  "search-preview": { view: "records", tab: "preview" },
};

const state = {
  tab: "catalog",
  view: "overview",
};

function syncHistory() {
  const url = new URL(window.location.href);
  url.hash = `#${state.view}`;

  if (state.view === "records" && state.tab !== "catalog") {
    url.searchParams.set("tab", state.tab);
  } else {
    url.searchParams.delete("tab");
  }

  window.history.replaceState({}, "", url);
}

function dispatchWorkspaceChange() {
  window.dispatchEvent(
    new CustomEvent("workspace:tab-changed", {
      detail: {
        tab: state.tab,
        view: state.view,
      },
    })
  );
}

function activateView(view) {
  state.view = view;

  viewPanels.forEach((panel) => {
    panel.hidden = panel.dataset.workspaceViewPanel !== view;
  });

  viewLinks.forEach((link) => {
    link.classList.toggle("is-active", link.dataset.workspaceViewLink === view);
  });
}

function activateTab(tab) {
  state.tab = tab;

  tabButtons.forEach((button) => {
    const isActive = button.dataset.workspaceTabTarget === tab;
    button.classList.toggle("is-active", isActive);
    button.classList.toggle("button--secondary", isActive);
    button.classList.toggle("button--ghost", !isActive);
  });

  tabPanels.forEach((panel) => {
    panel.hidden = panel.dataset.workspaceTabPanel !== tab;
  });
}

function applyState(nextState, options = {}) {
  activateView(nextState.view);

  if (nextState.view === "records") {
    activateTab(nextState.tab || state.tab || "catalog");
  }

  if (!options.skipHistory) {
    syncHistory();
  }

  dispatchWorkspaceChange();
}

function parseLocationState() {
  const url = new URL(window.location.href);
  const hash = url.hash.replace("#", "");
  const compatibleState = COMPATIBLE_HASHES[hash];

  if (compatibleState) {
    return compatibleState;
  }

  const recordId = url.searchParams.get("recordId");
  const tab = url.searchParams.get("tab");
  const hasView = viewPanels.some(
    (panel) => panel.dataset.workspaceViewPanel === hash
  );

  if (recordId) {
    return { view: "records", tab: tab || "editor" };
  }

  if (hash === "records") {
    return { view: "records", tab: tab || "catalog" };
  }

  if (hasView) {
    return { view: hash, tab: "catalog" };
  }

  return { view: "overview", tab: "catalog" };
}

function navigate(detail = {}, options = {}) {
  const nextState = {
    tab: detail.tab || state.tab || "catalog",
    view: detail.view || state.view || "overview",
  };

  applyState(nextState, options);
}

document.addEventListener("click", (event) => {
  const control = event.target.closest(
    "[data-workspace-view-link], [data-workspace-view-target], .workspace-tab"
  );

  if (!control) {
    return;
  }

  event.preventDefault();
  navigate({
    tab: control.dataset.workspaceTabTarget || undefined,
    view:
      control.dataset.workspaceViewLink ||
      control.dataset.workspaceViewTarget ||
      undefined,
  });
});

window.addEventListener("workspace:navigate", (event) => {
  navigate(event.detail || {});
});

window.addEventListener("hashchange", () => {
  applyState(parseLocationState(), { skipHistory: true });
});

applyState(parseLocationState(), { skipHistory: true });
